import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import TemplateEditorPage from './TemplateEditorPage';

export default function TemplateEditorWrapper() {
    const location = useLocation();
    const previousPathRef = useRef<string>(location.pathname);

    useEffect(() => {
        const currentPath = location.pathname;
        const previousPath = previousPathRef.current;

        // Force a full page reload when navigating to /templates/new from another template
        if (
            currentPath === '/templates/new' &&
            previousPath !== '/templates/new' &&
            previousPath.includes('/templates/')
        ) {
            // Check if we just reloaded (to prevent infinite reload)
            const justReloaded = sessionStorage.getItem('template_new_reloaded');
            if (!justReloaded) {
                sessionStorage.setItem('template_new_reloaded', 'true');
                window.location.reload();
            } else {
                sessionStorage.removeItem('template_new_reloaded');
            }
        }

        previousPathRef.current = currentPath;
    }, [location.pathname]);

    // Force remount when route changes by using pathname as a key
    return <TemplateEditorPage key={location.pathname} />;
}
